import { createFileRoute } from '@tanstack/react-router';
import { ProfileTicketsPage } from './-components/ProfileTicketsPage';

export const Route = createFileRoute('/profile/tickets')({
  component: ProfileTicketsPage,
});
